import {Breadcrumbs} from '@management-ui/core';
import {Paper} from '@mui/material';
import * as React from 'react';
import Table from './Table';

export default function Orders() {
  return (
    <div>
      <Breadcrumbs crumbs={[{title: 'Orders'}]}/>
      <Paper>
        <Table/>
      </Paper>
    </div>
  );
}
